import { View } from 'backbone.marionette';
import Backbone from 'backbone';

import StringCell from '@/backgrid/StringCell';
import RawHtmlCell from '@/backgrid/RawHtmlCell';
import DollarCell from '@/backgrid/DollarCell';

import OrderSummaryGridView from '../../../views/OrderSummaryGridView/OrderSummaryGridView';

import tmplPRTNRSummaryView from './PRTNRSummaryView.hbs';
import './PRTNRSummaryView.css';

const PRTNRSummaryView = View.extend({
  template: tmplPRTNRSummaryView,

  className: 'prtnr-summary-view',

  ui: {
    monoSummaryTable: '.mono-summary-table',
    colorSummaryTable: '.color-summary-table',
    servicesSummaryTable: '.services-summary-table',
    costSummaryTable: '.cost-summary-table'
  },

  regions: {
    monoSummaryTable: '@ui.monoSummaryTable',
    colorSummaryTable: '@ui.colorSummaryTable',
    servicesSummaryTable: '@ui.servicesSummaryTable',
    costSummaryTable: '@ui.costSummaryTable'
  },

  onRender() {
    this.columns = [
      {
        name: 'item',
        label: 'Item',
        cell: StringCell,
        headerCell: 'custom',
        width: 30,
        editable: false
      },
      {
        name: 'quantity',
        label: 'Quantity',
        cell: StringCell,
        headerCell: 'custom',
        width: 15,
        editable: false
      },
      {
        name: 'totalPrice',
        label: 'Monthly Total Cost',
        cell: DollarCell,
        headerCell: 'custom',
        width: 30,
        editable: false
      }
    ];

    this.costColumns = [
      {
        name: 'item',
        label: 'Item',
        cell: RawHtmlCell,
        headerCell: 'custom',
        width: 35,
        editable: false
      },
      {
        name: 'totalPrice',
        label: 'Total Cost',
        cell: DollarCell,
        headerCell: 'custom',
        width: 15,
        editable: false
      }
    ];

    this.monoCollection = new Backbone.Collection([
      {
        item: 'Unclassified Monochrome (B&W) MFD (NIPR)',
        quantity: this.model.get('orderTotals').totalMonoNiprQuantity,
        totalPrice: this.model.get('orderTotals').totalMonoNiprPrice
      },
      {
        item: 'Classified Monochrome (B&W) MFD (SIPR)',
        quantity: this.model.get('orderTotals').totalMonoSiprQuantity,
        totalPrice: this.model.get('orderTotals').totalMonoSiprPrice
      },
      {
        item: 'Total of Monochrome (B&W) MFD',
        quantity: this.model.get('orderTotals').totalMonoQuantity,
        totalPrice: this.model.get('orderTotals').totalMonoPrice
      }
    ]);

    this.colorCollection = new Backbone.Collection([
      {
        item: 'Unclassified Color MFD (NIPR)',
        quantity: this.model.get('orderTotals').totalColorNiprQuantity,
        totalPrice: this.model.get('orderTotals').totalColorNiprPrice
      },
      {
        item: 'Classified Color MFD (SIPR)',
        quantity: this.model.get('orderTotals').totalColorSiprQuantity,
        totalPrice: this.model.get('orderTotals').totalColorSiprPrice
      },
      {
        item: 'Total of Color MFD',
        quantity: this.model.get('orderTotals').totalColorQuantity,
        totalPrice: this.model.get('orderTotals').totalColorPrice
      }
    ]);

    this.servicesCollection = new Backbone.Collection([
      {
        item: 'Total of Additional Monthly Services',
        quantity: this.model.get('orderTotals').totalMonthlyAdditionalServicesQuantity,
        totalPrice: this.model.get('orderTotals').totalMonthlyAdditionalServicesPrice
      },
      {
        item: 'Total of One-Time Services',
        quantity: this.model.get('orderTotals').totalYearlyOneTimeServicesQuantity,
        totalPrice: this.model.get('orderTotals').totalYearlyOneTimeServicesPrice
      }
    ]);

    // Assumes that legacy cutoff (Sept 30) is no longer supported; see PRTNRGeneralView for details
    const numMonthsToFYEndLabel = `Number of months from Date Equipment Required through March 31, 2027: <strong class="ms-2">${this.model.get('order').numMonthsToFYEnd}</strong>`;

    this.costCollection = new Backbone.Collection([
      {
        item: 'One-Time Charges for Additional Services',
        totalPrice: this.model.get('orderTotals').totalYearlyOneTimeServicesPrice
      },
      {
        item: 'Recurring Monthly Cost (monthly charges)',
        totalPrice: this.model.get('orderTotals').totalMonthlyPrice
      },
      {
        item: numMonthsToFYEndLabel,
        totalPrice: null
      },
      {
        item: 'Total funding amount for this order',
        totalPrice:
          this.model.get('order').numMonthsToFYEnd * this.model.get('orderTotals').totalMonthlyPrice +
          parseInt(this.model.get('orderTotals').totalYearlyOneTimeServicesPrice)
      },
      {
        item: 'Total Annual Cost',
        totalPrice: this.model.get('orderTotals').totalMonthlyPrice * 12
      }
    ]);

    this.monoSummaryGridView = new OrderSummaryGridView({
      model: this.model,
      collection: this.monoCollection,
      columns: this.columns
    });
    this.showChildView('monoSummaryTable', this.monoSummaryGridView);

    this.colorSummaryGridView = new OrderSummaryGridView({
      model: this.model,
      collection: this.colorCollection,
      columns: this.columns
    });
    this.showChildView('colorSummaryTable', this.colorSummaryGridView);

    this.servicesSummaryGridView = new OrderSummaryGridView({
      model: this.model,
      collection: this.servicesCollection,
      columns: this.columns
    });
    this.showChildView('servicesSummaryTable', this.servicesSummaryGridView);

    this.costSummaryGridView = new OrderSummaryGridView({
      model: this.model,
      collection: this.costCollection,
      columns: this.costColumns
    });
    this.showChildView('costSummaryTable', this.costSummaryGridView);
  }
});

export default PRTNRSummaryView;
